<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <aside v-if="staging" class='staging-mode'>STAGING</aside>
    <aside v-if="global_message" class='noprint global_message'>{{ global_message }}</aside>
    <nav class='noprint'>
      <ul>
        <span v-if="$store.getters.is_authenticated">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/invoices">Goods In</router-link></li>
          <li><router-link to="/trays">Trays</router-link></li>
          <!-- <li><router-link to="/products">Products</router-link></li> -->
          <li><router-link to="/batches">Batches</router-link></li>
          <li><router-link to="/recipes">Recipes</router-link></li>
          <li><router-link to="/orders">Orders</router-link></li>
          <!-- <li><router-link to="/ordersp">[Product Orders]</router-link></li> -->
          <!-- <li><router-link to="/customers">Customers</router-link></li> -->
          <li><router-link to="/reports">Reports</router-link></li>
          <li><router-link to="/settings/general">Settings</router-link></li>
          <li><router-link v-if="$store.state.user.user_level >= 5" to="/users">Users</router-link></li>
          <li><router-link to="/logout">Log out</router-link></li>
        </span>
      </ul>
    </nav>
    <main>
      <transition mode='out-in' name='fade'>
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
  import { EventBus } from '@/eventbus';
  export default {
    name : 'app',
    data(){
      return {
        staging        : false,
        global_message : false
      }
    },
    created(){
      if("staging" in localStorage){
        console.log(`STAGING!!`);
        this.staging = true;
      }
      EventBus.$on('globalmessage', (msg) => {
        this.global_message = msg;
      })
    },
    methods : {
      showTray : function(){
        console.log(this.$store.getters.tray);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue